import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import "../../View.css";
import "../../Grid.css";
import "../../Form.css";
import "../../App.css";
import SearchView from "../../widgets/SearchView";
import { ViewContainer } from "../../View.jsx";
import ViewUtils from '../../ViewUtils';
import withMenuPermission from "../../widgets/withMenuPermission";
import APPMaintenanceSearchForm from './APPMaintenanceSearchForm';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Prompt from '../../widgets/Prompt';
import AlertItem from "../../widgets/AlertItem";

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}


const toolbarRef = React.createRef();
const utils = new ViewUtils();
const projectRef = React.createRef();

const headCells = [
    { id: 'FinancialYear', numeric: false, disablePadding: false, label: 'Financial Year' },
    { id: 'APPProgrammeStructure', numeric: false, disablePadding: false, label: 'Programme Structure' },
    { id: 'IndicatorNo', numeric: true, disablePadding: false, label: 'Indicator Number' },
    { id: 'IndicatorName', numeric: true, disablePadding: false, label: 'Indicator Name' },
    { id: 'ProjectId', numeric: false, disablePadding: false, label: 'Project ID' },
    { id: 'AnnualTargets', numeric: false, disablePadding: false, label: 'Annual Targets' },
    { id: 'CalculationType', numeric: false, disablePadding: false, label: 'Calculation Type' },
    { id: 'Q1Target', numeric: true, disablePadding: false, label: 'Q1 Target' },
    { id: 'Q2Target', numeric: true, disablePadding: false, label: 'Q2 Target' },
    { id: 'Q3Target', numeric: true, disablePadding: false, label: 'Q3 Target' },
    { id: 'Q4Target', numeric: true, disablePadding: false, label: 'Q4 Target' }
];

class APPMaintenanceSearch extends Component {

    constructor(props) {
        super(props)

        this.state = {
            model: {
                FinancialYearID: "",
                APPProgrammeStructureID: ""
            },
            modalOpen: false,
            projectmodel: {
                ProjectNumber: null
            },
            key: Math.floor(100000000 + Math.random() * 900000000),
            optionSelected: '',
            openImportModal: false,
            keyUpSwitch: false,
            selectedIndicator: null,
            projectData: null,
            showTable: true,
            selectedFinancialYear: null,
            message: "",
            messageType: "",
            selectedPType: null,
            propmtOpen: false,
            promptTitle: "Remove APP Indicator",
            promptContent: "Are you sure you want to remove this APP Indicator?",
            selectedFinancialYearDescription: "",
            RemoveMessage: "",
            RemoveMessageStyle: "",
            searchParameters: [
                { Name: "FinancialYearID", Value: 0 },
                { Name: "APPProgrammeStructureID", Value: 0 }
            ]
        };

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'downloadtemplate', label: 'DOWNLOAD TEMPLATE', tooltip: 'Download the template format to import', disabled: false },
                        { id: 'import', label: 'IMPORT TEMPLATE', tooltip: 'Import your populated template', disabled: false, visible: this.props.menuPermissionItem.Add },
                        { id: 'edit', label: '', tooltip: 'Edit', icon: 'EditIcon', disabled: true, visible: this.props.menuPermissionItem.Edit },
                        { id: 'remove', label: '', tooltip: 'Remove APP Indicator', icon: 'DeleteIcon', disabled: true, visible: this.props.menuPermissionItem.Delete }
                    ]
                }
            ]
        };
    }

    onkeyup(e) {
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    handleSelection = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ selectedIndicator: selection[0], selectedPType: "APP" })
            toolbarRef.current.setButtonDisabled("remove", false);
        } else {
            this.setState({ selectedIndicator: null })
        }
    }

    handleToolbarButtonClick = (buttonId) => {
        if (buttonId === "downloadtemplate") {
            this.downloadTemplate(this.state.projectType)
        }
        else if (buttonId === "import") {
            this.setState({ openImportModal: true });
        } 
        else if (buttonId === "edit") {
            this.props.history.push({
                pathname: '/APPIndicator',
                state: {
                    selection: this.state.selectedIndicator,
                    IsAdd: false
                }
            })
        } 
        else if ("remove" === buttonId) {
            this.setState({ promptOpen: true })
        }
    }

    downloadTemplate(Ptype) {
        utils.invokeUrl("api/sims/APPMaintenance/DownloadAppTemplate", (response) => {

            var blob = new Blob([this.base64ToArrayBuffer(response.Base64)], { type: response.Type });
            var url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = response.Name;
            link.target = '_blank';
            link.click();
        }
        );
    }

    base64ToArrayBuffer = (base64) => {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    };

    handleModelChange = (values) => {
        if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
            if (!utils.isNull(values.FinancialYearID.Description)) {
                this.setState({ model: values, selectedFinancialYearID: values.FinancialYearID.Id, selectedFinancialYearDescription: values.FinancialYearID.Description });
            }
            else {
                this.setState({ model: values });
            }
        }
    }

    handleOpenImportModal = () => {
        this.setState({ openImportModal: true });
    }

    handleCloseImportModal = () => {
        this.setState({ searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)), openImportModal: false, selectedFile: null, showTable: false }, () => {
            this.setState({ showTable: true })
        });
    }

    handleAlertOpen = () => {
        this.setState({ alertOpen: true, message: "Please select a valid Programme Structure" });
    };

    handleAlertClose = () => {
        this.setState({ alertOpen: false, message: "" });
    };

    handleFileChange = (event) => {
        this.setState({ selectedFile: event.target.files[0] });
    }

    handleImport = () => {
        if (this.state.selectedFile) {
            
            const reader = new FileReader();
            reader.onloadend = () => {
                let base64String = reader.result;
                base64String = base64String.split(',').pop();

                let data = {};
                data.Document = {};
                data.Document.Name = this.state.selectedFile.name;
                data.Document.size = this.state.selectedFile.size;
                data.Document.type = this.state.selectedFile.type;
                data.Document.base64 = base64String;
                data.Key = this.state.key;

                utils.invokeUrl(`api/sims/APPMaintenance/AppImport`, (response) => {
                    if (response.Status == "Fail") {
                        var blob = new Blob([this.base64ToArrayBuffer(response.Document.Base64)], { type: response.Document.Type });
                        var url = URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.download = response.Document.Name;
                        link.target = '_blank';
                        link.click();
                        this.setState({ alertOpen: true, message: "Import completed with errors, please see the downloaded import results.", messageType: "warning" });
                    } else if (response.Status == "Pass") {
                        this.setState({ alertOpen: true, message: "Import successful", messageType: "success", searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)) });
                        this.handleCloseImportModal();
                    };
                }, () => { },
                    {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': "Bearer " + localStorage.getItem("token")
                        },
                        body: JSON.stringify(data)
                    }
                );
            };
            
            reader.readAsDataURL(this.state.selectedFile);
        } else {
            this.handleAlertOpen();
        }
    }

    successfulNotificationCallback = (response) => {
        this.setState({ selectedIndicator: null, RemoveMessage: response.Message, RemoveMessageStyle: response.MessageType.toLowerCase(), showTable: false }, () => {
            this.setState({ showTable: true })
        });
    }

    unsuccessfulNotificationRemoveCallback = (response) => {
        if (!utils.isNull(response.Message) && response.Message !== "") {
            this.setState({ RemoveMessage: response.Message, RemoveMessageStyle: response.MessageType.toLowerCase() })
        }
    }

    RemoveProject(url) {
        this.setState({ promptOpen: false }, () => {
            toolbarRef.current.setButtonDisabled("remove", true);
        })

        let fullUrl = `${url}?id=${this.state.selectedIndicator.Id}`;
        utils.invokeUrlDelete(fullUrl, this.successfulNotificationCallback, this.unsuccessfulNotificationRemoveCallback);
    }

    closePrompt = () => {
        this.setState({ propmtOpen: false })
    }

    handleFormValueChange = (values) => {
        if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {

        }
    }

    handleProjectSelect = (values) => {
        if (Array.isArray(values) && values.length !== 0) {
            this.setState({ selectedIndicatorID: values[0].Id, selectedIndicatorDescription: values[0].Description, startingDate: values[0].StartingDate, endingDate: values[0].EndDate });
        }
    }

    handleCloseNextModal = () => {
        this.setState({ openNextModal: false, alertOpen: false, message: "", messageType: "" });
    }

    render() {
        return (
            <ViewContainer title="">

                <AlertItem message={this.state.RemoveMessage} alertStyle={this.state.RemoveMessageStyle} />
                {this.state.showTable === true && (
                    <SearchView headCells={headCells} dataUrl={!utils.isNull(this.props.dataUrl) ? this.props.dataUrl : "api/sims/APPMaintenance/GetSearch"}
                    model={this.state.model}
                    toolbarConfig={this.toolbarConfig} searchParameters={this.state.searchParameters}
                        title='Annual Performance Plan Maintenance'
                    mode={this.props.mode}
                    handleObject={true}
                    toolbarRef={toolbarRef}
                    history={this.props.history}
                        onLookupValueChange={this.props.onLookupValueChange} descriptionProp="IndicatorName"
                    buttonClickHandler={this.handleToolbarButtonClick}
                    keyUpSwitch={this.state.keyUpSwitch} 
                    promptTitle={"Remove APP Indicator"} 
                    setSelection={(selection) => { this.handleSelection(selection) }}
                    autoFetchData={false}
                >
                <APPMaintenanceSearchForm data={this.state.model} onKeyUp={(e) => { this.onkeyup(e) }}
                        valueChangeHandler={(values) => {
                            this.handleModelChange(values)
                        }} />
                </SearchView>
                )}

                <Dialog open={this.state.openImportModal} onClose={this.handleCloseImportModal}>
                    <DialogTitle>Import Excel File</DialogTitle>
                    <DialogContent>
                        <input type="file" accept=".xls,.xlsx" onChange={this.handleFileChange} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseImportModal} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={this.handleImport} color="primary">
                            Import
                        </Button>
                    </DialogActions>
                </Dialog>

                <Snackbar open={this.state.alertOpen} autoHideDuration={6000} onClose={this.handleAlertClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                    <Alert onClose={this.handleAlertClose} severity={this.state.messageType } >
                        {this.state.message}
                    </Alert>
                </Snackbar>

                <Prompt open={this.state.promptOpen}
                    promptTitle={this.state.promptTitle}
                    promptContent={this.state.promptContent}
                    handleYes={() => { this.RemoveProject("api/sims/APPMaintenance/RemoveAPPIndicator") }}
                    closePrompt={this.closePrompt}
                />

            </ViewContainer>
        );
    }
}


export default withRouter(withMenuPermission(APPMaintenanceSearch));

